import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-media-thumbnail',
  standalone: true,
  imports: [],
  templateUrl: './media-thumbnail.component.html',
  styleUrl: './media-thumbnail.component.scss',
})
export class MediaThumbnailComponent {
  @Input({ required: true }) thumbnailUrl!: string;

  @Input() isVideo: boolean = false;

  @Input() altText: string = '';

  onOpenInNewTab(event: MouseEvent): void {
    event.stopPropagation();
    window.open(this.thumbnailUrl, '_blank', 'noopener');
  }
}
